import { createTheme } from '@mui/material/styles';
import { color, font, bevel } from './styles/tokens';

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: { default: color.ink, paper: color.panel },
    text: { primary: color.bone, secondary: color.boneDim },
    primary: { main: color.cyan, dark: color.cyanDim, contrastText: color.ink },
    success: { main: color.teal },
    warning: { main: color.amber },
    error: { main: color.red },
    divider: color.ruleSoft,
  },
  shape: { borderRadius: 4 },
  typography: {
    fontFamily: font.body,
    h1: { fontFamily: font.display }, h2: { fontFamily: font.display },
    h3: { fontFamily: font.display }, h4: { fontFamily: font.display },
    h5: { fontFamily: font.display, fontWeight: 600 },
    h6: { fontFamily: font.display, fontWeight: 600 },
    button: { fontFamily: font.mono, textTransform: 'uppercase', letterSpacing: '.08em', fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { background: color.ink, color: color.bone },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          clipPath: bevel(8),
          borderRadius: 0,
        },
        containedPrimary: {
          background: color.cyanDim,
          color: color.ink,
          '&:hover': { background: color.cyan, boxShadow: `0 0 12px ${color.cyanGlow}` },
        },
        outlined: {
          borderColor: color.rule,
          color: color.boneDim,
          '&:hover': { borderColor: color.cyanDim, background: color.panel2, color: color.bone },
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined' },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: color.panel2,
          fontFamily: font.mono,
          fontSize: '0.875rem',
          '& fieldset': { borderColor: color.rule },
          '&:hover fieldset': { borderColor: color.boneFaint },
          '&.Mui-focused fieldset': { borderColor: color.cyan, borderWidth: 1 },
        },
        input: { color: color.bone },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: font.mono, fontSize: '0.75rem', letterSpacing: '.06em',
          color: color.boneFaint,
          '&.Mui-focused': { color: color.cyan },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { fontFamily: font.body, clipPath: bevel(6) },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { background: color.cyan, height: 2 },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: font.mono, fontSize: '.75rem', letterSpacing: '.08em',
          textTransform: 'uppercase', color: color.boneFaint,
          '&.Mui-selected': { color: color.bone },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: color.ruleSoft, fontFamily: font.body },
        head: {
          fontFamily: font.mono, fontSize: '.625rem', letterSpacing: '.1em',
          textTransform: 'uppercase', color: color.boneFaint, borderColor: color.rule,
        },
      },
    },
  },
});

export default theme;
